<form
  class="bg-surface border-default flex w-full flex-col overflow-hidden rounded-lg border shadow-lg"
  aria-labelledby="move-to-title"
  (submit)="$event.preventDefault(); move()">
  <div class="border-weak flex items-center gap-2 border-b px-3 py-2.5">
    <i class="text-accent-main" [class]="titleIcon()"></i>
    <h2
      id="move-to-title"
      class="text-text-primary min-w-0 flex-1 truncate text-sm font-semibold">
      {{
        'features.plan.edit.move_to.title.' +
          (request().allStops ? 'all_stops' : request().carried.kind) | translate
      }}
      <span class="font-mono">{{ request().name }}</span>
    </h2>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer rounded-xs transition-colors"
      [attr.aria-label]="'common.close' | translate"
      (click)="done.emit()">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  <div class="flex flex-col gap-3 p-3">
    <div class="flex flex-col gap-1">
      <label for="move-to-route" class="form-label mb-0 text-xs">
        {{ 'features.plan.edit.move_to.route' | translate }}
      </label>
      <app-select
        id="move-to-route"
        [items]="routeItems()"
        [value]="chosenRouteUid()"
        [searchable]="true"
        (valueChange)="onRoute($event)" />
      <div class="flex items-center gap-3">
        <button
          type="button"
          data-testid="move-to-other-route"
          class="text-accent-main hover:text-accent-hover cursor-pointer rounded-xs text-xs transition-colors"
          (click)="pickOther()">
          {{ 'features.plan.edit.move_to.other_route' | translate }}
        </button>
        <button
          type="button"
          data-testid="move-to-new-route"
          class="text-accent-main hover:text-accent-hover inline-flex cursor-pointer items-center gap-1 rounded-xs text-xs transition-colors"
          (click)="moveToNewRoute()">
          <i [class]="ICONS.plus" aria-hidden="true"></i>
          {{ 'features.plan.edit.move_to.new_route' | translate }}
        </button>
      </div>
    </div>

    <fieldset class="m-0 flex min-w-0 flex-col gap-1 border-0 p-0">
      <legend class="form-label mb-1 p-0 text-xs">
        {{ 'features.plan.edit.move_to.position' | translate }}
      </legend>
      @if (positions().length === 0) {
        <p class="form-help">{{ 'features.plan.edit.move_to.no_position' | translate }}</p>
      } @else {
        <div class="scrollbar-thin flex max-h-56 flex-col overflow-y-auto">
          @for (position of positions(); track $index; let i = $index) {
            <label
              class="hover:bg-interactive has-checked:bg-accent-interactive has-focus-visible:outline-accent-focus flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm transition-colors has-focus-visible:outline-2">
              <input
                type="radio"
                name="move-to-position"
                class="accent-accent-main size-3.5 shrink-0 cursor-pointer"
                [checked]="i === positionIndex()"
                (change)="positionIndex.set(i)" />
              <span class="text-text-primary min-w-0 flex-1 truncate">
                @switch (position.target.label) {
                  @case ('merge') {
                    {{ 'features.plan.edit.move_to.into_stop' | translate }}
                    <span class="font-mono">{{ position.site }}</span>
                  }
                  @case ('gap') {
                    {{ 'features.plan.edit.move_to.before' | translate }}
                    <span class="font-mono">{{ position.site }}</span>
                  }
                  @default {
                    {{ 'features.plan.edit.move_to.end' | translate }}
                  }
                }
              </span>
              @if (position.time) {
                <span class="text-text-tertiary shrink-0 font-mono text-xs tabular-nums">
                  {{ position.time }}
                </span>
              }
            </label>
          }
        </div>
      }
    </fieldset>
  </div>

  <div class="border-weak flex items-center justify-end gap-2 border-t px-3 py-2.5">
    <button type="button" class="btn btn-cancel" (click)="done.emit()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="submit"
      data-testid="move-to-submit"
      class="btn btn-primary"
      [disabled]="!chosen()">
      {{ 'features.plan.edit.move_to.move' | translate }}
    </button>
  </div>
</form>
